import { observer } from 'mobx-react-lite'
import { Box, Divider } from 'shared/ui'
import { Select } from 'shared/ui/Select/Select'
import { DoubleOptInSettingLayout } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInSetting/DoubleOptInSettingLayout'
import { useNotificationsContext } from 'pages/settings/pages/notifications/context/notificationsContext'
import { ANALYTICS_FREQUENCY_ITEMS } from 'pages/settings/pages/notifications/constants/constants'
import styles from './styles.module.scss'

export const Options = observer(() => {
  const {
    analyticsReportSelectionValues,
    ringEverywhere,
    toggleRingEverywhere,
    toggleNotificationsSettings,
    notificationsSettings,
    analyticsReport,
    toggleAnalyticsReportActive,
    analyticsReportActiveAndFrequenciesLoading,
    isShowAnalyticsSelect,
    setAnalyticsReportSelectedValues,
    closeAnalyticsReportDropdown,
    analyticsFrequencyText,
    isMemberOrObserver,
  } = useNotificationsContext()

  const titleEmailNotificationsSettings = 'Email notifications updated'

  return (
    <Box padding='0 20px'>
      <DoubleOptInSettingLayout
        title={'Ring everywhere'}
        description={
          'Make the incoming ringtone play on your headset and computer speakers at the same time'
        }
        checked={ringEverywhere}
        onToggle={toggleRingEverywhere}
        className={styles.toggleItem}
      />
      <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
      <DoubleOptInSettingLayout
        title={'Email'}
        description={'Receive notifications via email'}
        checked={notificationsSettings?.email}
        onToggle={() => toggleNotificationsSettings('email')}
      />
      {notificationsSettings?.email && (
        <>
          <DoubleOptInSettingLayout
            variant={'checkbox'}
            title={'Conversations assigned to me'}
            titleVariant={'body-md-regular'}
            checked={notificationsSettings?.email_about_assigned_to_me}
            onToggle={() =>
              toggleNotificationsSettings(
                'email_about_assigned_to_me',
                titleEmailNotificationsSettings
              )
            }
          />
          <DoubleOptInSettingLayout
            variant={'checkbox'}
            title={'Conversations assigned to other users'}
            titleVariant={'body-md-regular'}
            checked={notificationsSettings?.email_about_assigned_to_other}
            onToggle={() =>
              toggleNotificationsSettings(
                'email_about_assigned_to_other',
                titleEmailNotificationsSettings
              )
            }
          />
          <DoubleOptInSettingLayout
            variant={'checkbox'}
            title={'Unassigned conversations'}
            titleVariant={'body-md-regular'}
            checked={notificationsSettings?.email_about_unassigned}
            onToggle={() =>
              toggleNotificationsSettings('email_about_unassigned', titleEmailNotificationsSettings)
            }
          />
          <DoubleOptInSettingLayout
            variant={'checkbox'}
            title={'Missed calls'}
            titleVariant={'body-md-regular'}
            checked={notificationsSettings?.email_about_missed_calls}
            onToggle={() =>
              toggleNotificationsSettings(
                'email_about_missed_calls',
                titleEmailNotificationsSettings
              )
            }
          />
          <DoubleOptInSettingLayout
            variant={'checkbox'}
            title={'Voicemails'}
            titleVariant={'body-md-regular'}
            checked={notificationsSettings?.email_about_voicemails}
            onToggle={() =>
              toggleNotificationsSettings('email_about_voicemails', titleEmailNotificationsSettings)
            }
          />
        </>
      )}
      {!isMemberOrObserver && (
        <>
          <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
          <DoubleOptInSettingLayout
            title={'Activity report via email'}
            description={'Receive a breakdown of your messaging and calling analytics by email'}
            checked={analyticsReport.active}
            onToggle={toggleAnalyticsReportActive}
            disabled={analyticsReportActiveAndFrequenciesLoading}
            switcherLeftContent={(checked) =>
              checked && isShowAnalyticsSelect ? (
                <Select
                  type='multi'
                  text={analyticsFrequencyText}
                  values={analyticsReportSelectionValues}
                  onSelectValues={setAnalyticsReportSelectedValues}
                  items={ANALYTICS_FREQUENCY_ITEMS}
                  hideBadge
                  btnProps={{
                    typeBtn: 'stroke',
                    fontWeight: 400,
                    disabled: analyticsReportActiveAndFrequenciesLoading,
                  }}
                  dropdownProps={{
                    onClose: closeAnalyticsReportDropdown,
                    placement: 'bottom-end',
                    width: 200,
                    PopperProps: {
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            offset: ({ reference }) => {
                              return [1, -reference.height - 4]
                            },
                          },
                        },
                      ],
                    },
                  }}
                />
              ) : null
            }
          />
        </>
      )}
    </Box>
  )
})
